const mapMessages = {
  'map.SearchLatLng.title': '位置情報の入力',
  'map.SearchLatLng.title.lat': '緯度：',
  'map.SearchLatLng.title.lng': ', 経度：',
  'map.SearchLatLng.placeholder.address': '住所を入力して検索してください',
  'map.SearchLatLng.button.search': '検索',
  'map.SearchLatLng.button.set': '設定',
};

export default mapMessages;
